import { render, staticRenderFns } from "./PlateKeyboard.vue?vue&type=template&id=08d6087c&scoped=true"
import script from "./PlateKeyboard.vue?vue&type=script&lang=js"
export * from "./PlateKeyboard.vue?vue&type=script&lang=js"
import style0 from "./PlateKeyboard.vue?vue&type=style&index=0&id=08d6087c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d6087c",
  null
  
)

export default component.exports